import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify'
import api from "../services/api";
import axios from "axios";
import { FormatDate } from "../helpers/FormatDate";

export const context = createContext()


export default function ContextProvider({ children }) {
    const [openMenu, setOpenMenu] = useState(false);
    const [darkMode, setDarkMode] = useState(false);
    const [loading, setLoading] = useState(false);
   
    const [suport, setSuport] = useState(false)
    const [loaderLogin, setLoaderLogin] = useState(false);
    const [refresh, setRefresh] = useState(false)
    const [clientSelected, setClientSelected] = useState('')
    const navigate = useNavigate();

    const getInitialUser = () => {
        const session = sessionStorage.getItem('User');
        if (session) {
            return JSON.parse(session);
        }
        return null;
    };
    
    const [user, setUser] = useState(getInitialUser);
    const [signed, setSigned] = useState(!!getInitialUser());

    useEffect(() => {
        if (user && window.location.pathname === '/') {
            navigate('/home');
        }
        setLoaderLogin(false);
    }, []);

    async function RunLogin(user, password, remember) {
        setLoaderLogin(true);

        await axios.get(`${api}login/${user}/${password}`)
            .then((res) => {
                if (res.data.success === true) {
                    const userData = {
                        Usuario: user,
                        Suporte: user === 'SUPORTE' ? true : false,
                    };
                    setUser(userData);
                    sessionStorage.setItem("User", JSON.stringify(userData));
                    if (remember) {
                        localStorage.setItem("Credentials", JSON.stringify({ Usuario: user }));
                    } else {
                        localStorage.removeItem("Credentials");
                    }
                    setSigned(true);
                    navigate('/home');
                } else {
                    toast.error("Usuário ou senha incorretos");
                }
            })
            .catch((error) => {
                toast.error("Erro ao realizar login, verifique os seus dados");
            })
            .finally(() => setLoaderLogin(false));
    }

    const [departamentList, setDepartamentList] = useState([])
    const [products, setProducts] = useState([])
    const [canaisList, setCanaisList] = useState([])

    async function getDepartament() {
        await axios.get(`${api}region`)
            .then((res) => {
                setLoading(false)
                setDepartamentList(res.data)
            })
            .catch((error) => {
                console.log('Erro ao buscar produtos', error)
                setLoading(false)
            })
    }

    async function getCanais() {
        await axios.get(`${api}saleschannel`)
            .then((res) => {
                setLoading(false)
                setCanaisList(res.data)
            })
            .catch((error) => {
                console.log('Erro ao buscar produtos', error)
                setCanaisList(false)
                setLoading(false)
            })
    }

    useEffect(() => {
        if(user){
            async function getProducts() {
                setLoading(true)
                await axios.get(`${api}product/listarprodutos/${user.Usuario}`)
                    .then((res) => {
                        setLoading(false)
                        setProducts(res.data)
                    })
                    .catch((error) => {
                        console.log('Erro ao buscar produtos', error)
                        setLoading(false)
                    })
            }
            getProducts()
            getDepartament()
            getCanais()
        }
    }, [user])

    const [contracts, setContracts] = useState([])

    async function getContracts() {
        setLoading(true)
        await axios.get(`${api}contract/${user.Usuario}`)
            .then((response) => {
                setContracts(response.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log('Erro ao buscar contratos', error)
                toast.error('Erro ao buscar contratos', error)
                setLoading(false)
            })
    }

    useEffect(() => {
        if (user !== null) {
            getContracts()
        }
    }, [user])

    const [dateStart, setDateStart] = useState(new Date())
    const [dateEnd, setDateEnd] = useState(new Date())
    const [transactions, setTransactions] = useState([])
    const [order, setOrder] = useState({ produtos: {}, total: 0 });

    async function getTransactions() {
        setLoading(true)
        await axios.get(`${api}cashier/${user.Usuario}?dtInicial=${FormatDate(dateStart)}&dtFinal=${FormatDate(dateEnd)}`)
            .then((res) => {
                setTransactions(res.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log('Erro ao buscar transações do caixa', error)
                toast.error('Erro ao buscar transações do caixa')
                setLoading(false)
            })
    }

    return (
        <context.Provider value={{
            openMenu, setOpenMenu,
            darkMode, setDarkMode,
            RunLogin, loading, setLoading,
            signed, user, setSigned, setSuport, suport,
            clientSelected, setClientSelected,
            departamentList, setDepartamentList,
            products, setProducts, canaisList,
            getContracts, contracts, setContracts, getTransactions, dateStart, setDateStart,
            dateEnd, setDateEnd, transactions, setTransactions, loaderLogin, setLoaderLogin,
            refresh, setRefresh, order, setOrder
        }}>
            {children}
        </context.Provider>
    )
}